export const ROUTES = {
  home: {
    path: "/",
    title: "Home",
  },
  settings: {
    path: "/instellingen",
    title: "Instellingen",
  },
  profiel: {
    path: "/profiel",
    title: "Profiel",
  },
  avatarSelectie: {
    path: "/avatarselectie",
    title: "AvatarSelectie",
  },
  instellingen: {
    path: "/instellingen",
    title: "Instellingen",
  },
  NL: {
    path: "/missies/NL",
    title: "NL",
  },
  BE: {
    path: "/missies/BE",
    title: "BE",
  },
  DE: {
    path: "/missies/DE",
    title: "DE",
  },
  FR: {
    path: "/missies/FR",
    title: "FR",
  },
  ML: {
    path: "/missies/ML",
    title: "ML"
  },
  prestaties: {
    path: "/prestaties",
    title: "Prestaties",
  },
  OntwijkSpel: {
    path: "/ontwijkspel",
    title: "OntwijkSpel",
  },
  nieuws: {
    path: "/nieuws",
    title: "Nieuws",
  },
  landing: {
    path: "/landing",
    title: "landing",
  },

};
